<template>

  <div class="col-container-card-annonce col-12 col-sm-12 col-md-6 col-lg-4" :class="classWithConditions">
    <div class="placeholder-card-annonce" :class="{'placeholder-gradient': isGradient, 'placeholder-animated': isAnimated}">
    </div>
  </div>

</template>

<script>

export default {
  name: 'PlaceholderCardAnnonce',

  props:{
    customDisplayClass: {
      default: "",
      required: false
    },
    isGradient: {
      required: true
    },
    isAnimated: {
      required: true
    },
    isForHome: {
      default: false
    }
  },

  computed: {

    classWithConditions() {
      var searchHomeClass = this.isForHome ? "col-container-card-annonce-home col-8 col-sm-8 col-md-3 col-lg-3" : "col-12 col-sm-12 col-md-6 col-lg-4"
      return this.customDisplayClass + " " + searchHomeClass
    }
  },

}

</script>

<style scoped>

.placeholder-card-annonce {
  border-radius: var(--fourth-border-radius);
  background-color: var(--main-black-medium);
  height: calc(142px + 10px + 10px);
}
.placeholder-card-annonce.placeholder-gradient {
  background-image: var(--linear-gradient-main-black-medium);
}

.placeholder-animated {
  background: var(--linear-gradient-main-black-medium-animated);
  background-size: 400% 400%;

  animation: var(--place-holder-annonce-card-animation) 9s ease infinite;
  -webkit-animation: var(--place-holder-annonce-card-animation) 9s ease infinite;
  -moz-animation: var(--place-holder-annonce-card-animation) 9s ease infinite;
}

.col-container-card-annonce-home {
  padding-left: 0.5em;
  padding-bottom: 0.5em;
  padding-right: 0px;
}

</style>



// WEBPACK FOOTER //
// src/views/search/PlaceholderCardAnnonce.vue